// 七牛云全局配置（bucket：talin-mini，华南 z2）
// 已绑定正式加速域名 qiniu.guotajituan.com（https）。
// 后端 .env 的 QINIU_DOMAIN 与此保持一致（token 接口下发优先生效，前端无需改）；
// 这里的值为兜底，token 接口未下发 domain 时使用。
export const QINIU_UPLOAD_URLS = {
  CXC: 'https://up-z0.qiniup.com',
  ECN: 'https://up.qiniup.com',
  NCN: 'https://up-z1.qiniup.com',
  SCN: 'https://up-z2.qiniup.com'
}

// 默认上传区域：华南 z2（与 bucket 所在区一致，传错区域报 incorrect region）
export const QINIU_DEFAULT_REGION = 'SCN'

// 上传成功后拼外链的默认域名（token 接口未下发 domain 时兜底）
export const QINIU_DOMAIN = 'https://qiniu.guotajituan.com'
